export const ORDER = '/order'
export const CONFIG = '/config'
export const API = '/api'



// WEBPACK FOOTER //
// ./src/api/base.js